import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { certificates, ExtraCertificates } from "../Data";

const Certificates = ({
  heading = "Quality And Honour Certificates",
}) => {
  const [activeTab, setActiveTab] = useState("Iris");
  const [showMore, setShowMore] = useState(false);

  const filteredCertificates = certificates.filter(
    (item) => item.category === activeTab
  );

  const staggerContainer = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.08,
      },
    },
  };

  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 30,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  const scaleIn = {
    hidden: {
      opacity: 0,
      scale: 0.94,
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.45,
        ease: "easeOut",
      },
    },
  };

  return (
    <section className="slider-section certificates-section container">
      {/* =========================
          HEADING
      ========================= */}

      {heading && (
        <motion.h2
          className="section-heading"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {heading}
        </motion.h2>
      )}

      {/* =========================
          TABS
      ========================= */}

      <motion.div
        className="certificate-tabs"
        variants={staggerContainer}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        {["Iris", "Ashirwad"].map((tab) => (
          <motion.button
            key={tab}
            variants={fadeUp}
            whileHover={{
              y: -3,
            }}
            whileTap={{
              scale: 0.96,
            }}
            className={`certificate-btn ${
              activeTab === tab ? "active" : ""
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab.toUpperCase()}
          </motion.button>
        ))}
      </motion.div>

      {/* =========================
          CERTIFICATES
      ========================= */}

      <AnimatePresence mode="wait">
        <motion.div
          key={activeTab}
          className="certificate-grid"
          variants={staggerContainer}
          initial="hidden"
          animate="visible"
          exit={{
            opacity: 0,
            y: 20,
            transition: {
              duration: 0.25,
            },
          }}
        >
          {filteredCertificates.map((item) => (
            <motion.div
              key={item.title}
              className="certificate-card"
              variants={scaleIn}
              whileHover={{
                y: -8,
                transition: {
                  duration: 0.25,
                },
              }}
            >
              <div className="certificate-image">
                <img
                  src={item.src}
                  alt={`${item.title} | Iris Impulse India Pvt. Ltd.`}
                />
              </div>

              <div className="certificate-content">
                <h3 className="card-heading">{item.title}</h3>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </AnimatePresence>

      {/* =========================
          SHOW MORE BUTTON
      ========================= */}

      {!showMore && (
        <motion.div
          className="show-more-wrapper"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <motion.button
            className="outline-btn"
            whileHover={{
              y: -3,
            }}
            whileTap={{
              scale: 0.96,
            }}
            onClick={() => setShowMore(true)}
          >
            Show More
          </motion.button>
        </motion.div>
      )}

      {/* =========================
          EXTRA CERTIFICATES
      ========================= */}

      <AnimatePresence>
        {showMore && (
          <motion.div
            className="certificate-masonry"
            variants={staggerContainer}
            initial="hidden"
            animate="visible"
            exit={{
              opacity: 0,
              transition: {
                duration: 0.3,
              },
            }}
          >
            {ExtraCertificates.map((item, index) => (
              <motion.div
                key={index}
                className={`masonry-card ${item.type}`}
                variants={fadeUp}
                whileHover={{
                  y: -6,
                }}
              >
                <img
                  src={item.src}
                  alt={`${item.title} | Iris Impulse India Pvt. Ltd.`}
                />

                <div className="certificate-content">
                  <h3 className="card-heading">{item.title}</h3>
                </div>
              </motion.div>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default Certificates;